import { Button, H3, H5, Intent } from "@blueprintjs/core";
import { useState } from "react";
import styled from "styled-components";
import * as Sentry from "@sentry/react";
import * as React from "react";

import { IError } from "../service/logger/ILoggerService";
import { currentMode } from "../util/Mode";
import Label from "./label/Label";
import TokenSession from "../util/session/TokenSession";
import { IconNames } from "@blueprintjs/icons";

const Container = styled.div`
	border: 1px solid #ebccd1;
	padding: 20px 20px 20px 20px;
	margin: 10px;
	background: #fff;
`;

const ErrorMessage = styled.div`
	color: #a94442;
	margin-bottom: 10px;
`;

const FriendlyMessage = styled.div`
	margin-bottom: 10px;
`;

const More = styled.div`
	font-size: 11px;
`;

interface IErrorDisplayProps {
	type: string;
	devTitle?: string;
	location: string;
	error: IError;
}

const showReport = (errorCode: string) => {
	Sentry.showReportDialog({
		user: {
			email: TokenSession.getUser().email,
			name: TokenSession.getUser().getName()
		}
	});
};

export const ErrorDisplay: React.SFC<IErrorDisplayProps> = ({error, location, devTitle, type, children}) => {
	const [more, setMore] = useState(false);
	const prod = currentMode.isProd();

	return (
		<Container key={error.errorCode}>

			<H3>
				{prod || !devTitle ? (
					<Label k="error.title" v="Something went wrong" />
				) : (
					devTitle
				)}
			</H3>

			{prod ? (
				<H5><Label k="error.code" args={{code: error.errorCode}} v="Error Code: ${code}" /></H5>
			) : (
				<H5>{type} - {location}</H5>
			)}

			{prod ? (
				<FriendlyMessage>
					<Label k="error.message" v="We're sorry for the inconvenience. This issue has been automatically reported to our system." />
				</FriendlyMessage>
			) : (
				<ErrorMessage>
					{error.message + "... "}

					{more ? (
						<a onClick={(() => setMore(false))}>Less</a>
					) : (
						<a onClick={(() => setMore(true))}>More</a>
					)}
				</ErrorMessage>
			)}

			{(!prod && more && (
				<More>
					<pre>
						{error.info && error.info.componentStack || error.info || JSON.stringify(error)}
					</pre>
				</More>
			))}

			{(prod) && (
				<Button
					onClick={() => showReport(error.errorCode)}
					icon={IconNames.HELP} style={{marginRight: "10px"}}
					intent={Intent.PRIMARY}
					minimal={true}
				>
					<Label k="assistance" v="Assistance"/>
				</Button>
			)}

			{children}
		</Container>
	);
};



// WEBPACK FOOTER //
// ./src/core/components/ErrorDisplay.tsx